import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IDictionary } from '../../interfaces/dictionary.interface';

export const validateAllFormFields = (
  formGroup: FormGroup | FormArray
): void => {
  // This code also works in IE 11
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof FormGroup) {
      validateAllFormFields(control);
    } else if (control instanceof FormArray) {
      validateAllFormFields(control);
    }
  });
};

export const arrayToObject = <T>(
  array: T[],
  key: (x: T) => string | number,
  value: (x: T) => unknown,
  filter?: (x: T) => boolean
): IDictionary<T> => {
  // { [key: string]: T } => {
  if (!array || array.length === 0) {
    return {};
  }
  const filteredArray = filter ? array.filter((x) => filter(x)) : [...array];
  if (filteredArray.length === 0) {
    return {};
  }

  //* Add in the reduced obj the new obj  of {item.id: {...item}}
  // const check = filteredArray.reduce((obj, item: T) => {

  //   obj[key(item)] = value(item);
  //   return obj;
  // }, {});

  return filteredArray.reduce(
    (obj, item: T) => ((obj[key(item)] = value(item)), obj),
    {}
  );
};
